/* eslint-disable */
<template>
  <div class="md:mx-auto md:p-4 px-2">
      <!-- Visiting the clinic -->
      <div>
        <div class="font-default text-2xl mb-4">
          Visiting the clinic
        </div>
        <div class="md:flex md:justify-evenly">
            <img class="mb-2 md:mb-0" src="/images/clinic_1.jpg"/>
            <img src="/images/clinic_2.jpg"/>
        </div>
        <!-- Instructions -->
        <div class="pt-4">
          You will need to sign a GDPR form.<p/>          
          <div class="mt-4">
            In case if you need a chaperone present during the examination and treatment then please bring either a friend or a family member.<br/><br/>
            <p><b>Osteopathic Clinic Directions:</b></p><br/>
            Located directly to the right of the GP surgery reception. As you approach the reception, look for the Osteopathy sign on your right and follow the instructions.<br/>
            A car park is located at the back of the building. Please be advised the car park has a car recognition system in operation. Bring your car registration number with you to register.<br/>            
          </div>
        </div>      
        <br/>   
        <a target="_blank" href="https://maps.app.goo.gl/P8nHU3BN1JNVMUAZ7"><img class="map-style" src="/images/map.png"/></a>
        <br />
        <div class="font-default font-bold">
        <a target="_blank" href="https://maps.app.goo.gl/P8nHU3BN1JNVMUAZ7">Open map</a>
        </div>
        <div class="mt-4 text-xs font-default font-bold">
          97 Church Street, 
          <p/>Werrington, 
          <p/>Peterborough, 
          <p/>Cambridgeshire,
          <p/>PE4 6QF
        </div>
        <div class="mt-2 text-xs font-default font-bold text-teal-700">
          Call <a href="tel: +447974 406635">07974 406635</a> or <a href="https://api.whatsapp.com/send?phone=447974406635">WhatsApp</a>
        </div>
      </div>
  </div>
</template>

<script>
import { Loader } from 'google-maps';
export default {
    async mounted() {
      this.$store.commit("setCurrentPage", "Contact");
    },
    data() {
      return {
        location: null,
      }
    },
    methods: {      
    }
}
</script>

<style>
.map-style {
  width: 600px;
  margin: auto;
}

@media screen and (min-width: 768px){
  .map-style {
    height: 500px;
    width: 500px;
    margin-left: 0px;
  }
}

</style>